import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import { ContentProvider } from './content/ContentContext';
import ScrollToTop from './components/ScrollToTop';
import Layout from './components/Layout';
import Home from './pages/Home';
import Courses from './pages/Courses';
import About from './pages/About';
import Schools from './pages/Schools';
import Contact from './pages/Contact';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import CoursePortal from './pages/CoursePortal';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import NewsAdmin from './pages/admin/NewsAdmin';
import LeadsAdmin from './pages/admin/LeadsAdmin';
import CoursewareAdmin from './pages/admin/CoursewareAdmin';
import BrandAdmin from './pages/admin/BrandAdmin';

function App() {
  return (
    <BrowserRouter>
      <ContentProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/news" element={<NewsAdmin />} />
          <Route path="/admin/leads" element={<LeadsAdmin />} />
          <Route path="/admin/courseware" element={<CoursewareAdmin />} />
          <Route path="/admin/brand" element={<BrandAdmin />} />

          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="courses" element={<Courses />} />
            <Route path="course-portal" element={<CoursePortal />} />
            <Route path="team" element={<About />} />
            <Route path="news" element={<News />} />
            <Route path="news/:slug" element={<NewsDetail />} />
            <Route path="about" element={<About />} />
            <Route path="schools" element={<Schools />} />
            <Route path="contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </ContentProvider>
    </BrowserRouter>
  );
}

export default App;


